(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('WorkingDaySearch', WorkingDaySearch);

    WorkingDaySearch.$inject = ['$resource'];

    function WorkingDaySearch($resource) {
        var resourceUrl =  'api/_search/working-days/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
